export function stickToFooter(element, options){

    let verticalOffset, selector;
    if(options){
        verticalOffset = options.verticalOffset;
        selector = options.selector;
    }

    if(verticalOffset === undefined){
        verticalOffset = 10;
    }

    if(selector === undefined){
        selector = '.brackset-footer'
    }

    let footer = document.querySelector(selector);
    if(footer){
        let observerOptions = {rootMargin: "50px 0px 0px 0px"};
        let footerObserver = new IntersectionObserver(
            function(entries, footerObserver){
                entries.forEach(entry => {
                    if(!entry.isIntersecting){
                        element.style.bottom = verticalOffset + 'px';                
                        element.style.top = null;             
                        element.style.position = 'fixed'; 

                    }else{
                        element.style.bottom = null; 
                        var style = element.currentStyle || window.getComputedStyle(element);
                        let marginTop = isNaN(parseInt(style.marginTop)) ? 0 : parseInt(style.marginTop);
                        let marginBottom = isNaN(parseInt(style.marginBottom)) ? 0 : parseInt(style.marginBottom);
                        
                        element.style.top = (document.body.scrollHeight - entry.boundingClientRect.height - element.clientHeight - marginBottom - marginTop - verticalOffset) + 'px';            
                        element.style.position = 'absolute'; 
                        
                    }
                })
            },
            observerOptions
        )

        footerObserver.observe(footer);
    }
}

//TODO: See why in PWA, this gets all jumpy when we scroll
//When scrolling hits the bottom of the header, move the bracket masthead to the top
export function makeNewHeader(element, options){

    let verticalOffset, selector;
    if(options){
        verticalOffset = options.verticalOffset;
        selector = options.selector;
    }

    if(verticalOffset === undefined){
        verticalOffset = 10;
    }

    if(selector === undefined){
        selector = '.brackset-header'
    }

    //brackset-header-light
    let scrollPoint = document.querySelector(selector);

    if(scrollPoint && scrollPoint.style.display !== 'none'){
        // let scrollPointStyle = scrollPoint.currentStyle || window.getComputedStyle(scrollPoint);
        // let scrollPointHeight = isNaN(parseInt(scrollPointStyle.height)) ? 0 : parseInt(scrollPointStyle.height);

        let content = element.querySelector('.bracket-header-content');
        let contentStyle = content.currentStyle || window.getComputedStyle(content);
        let contentPaddingTop = isNaN(parseInt(contentStyle.marginTop)) ? 0 : parseInt(contentStyle.marginTop);

        let followingElement = element.nextSibling;

        console.log(contentPaddingTop);
        // let observerOptions = {
        //     rootMargin: -25 + contentPaddingTop + "px 0px 0px 0px",
        // };
        let observerOptions = {
            threshold: 0,
        };

        let scrollPointObserver = new IntersectionObserver(
            function(entries, scrollPointObserver){
                    entries.forEach(entry => {
                        if(!entry.isIntersecting){
                                
                            setMastheadInScroll(element, content, followingElement, contentPaddingTop);
                            //Strangely, I need to do the padding change first so that the PWA doesn't repeatedly trigger this observer back and forth
                            // let newElementStyle = element.currentStyle || window.getComputedStyle(element);

                            // followingElement.style.paddingTop = parseInt(newElementStyle.height) + contentPaddingTop + 'px';

                            // // debugDiv.innerHTML = parseInt(newElementStyle.height) + contentPaddingTop + 'px';
                                
                            // element.classList.add('bracket-masthead-fixed');
                            // content.classList.add('bracket-masthead-content-fixed');

                        }else{
                                
                            setMastheadInPlace(element, content, followingElement);
                                // followingElement.style.paddingTop = '0'; 
                                // // debugDiv.innerHTML = 'empty';  
                                // element.classList.remove('bracket-masthead-fixed');                        
                                // content.classList.remove('bracket-masthead-content-fixed');                 
                        }
                    })
                    
            },
            observerOptions
        )

        scrollPointObserver.observe(scrollPoint);
    }

    function setMastheadInScroll(element, content, followingElement, contentPaddingTop){

        //Strangely, I need to do the padding change first so that the PWA doesn't repeatedly trigger this observer back and forth
        let newElementStyle = element.currentStyle || window.getComputedStyle(element);

        // followingElement.style.paddingTop = parseInt(newElementStyle.height) + contentPaddingTop + 'px';
        followingElement.style.paddingTop = parseInt(newElementStyle.height) + 'px';

        // let debugDiv = element.querySelector('.masthead-debug');
        // debugDiv.innerHTML = contentPaddingTop + 'px';
            
        element.classList.add('bracket-masthead-fixed');
        content.classList.add('bracket-masthead-content-fixed');
    }

    function setMastheadInPlace(element, content, followingElement){

        followingElement.style.paddingTop = '0'; 
        
        // let debugDiv = element.querySelector('.masthead-debug');
        // debugDiv.innerHTML = 'empty';  
        element.classList.remove('bracket-masthead-fixed');                        
        content.classList.remove('bracket-masthead-content-fixed');     
    }
}